import { render } from "./FaqComponent.vue?vue&type=template&id=233836ab&scoped=true"
import script from "./FaqComponent.vue?vue&type=script&lang=js"
export * from "./FaqComponent.vue?vue&type=script&lang=js"

import "./FaqComponent.vue?vue&type=style&index=0&id=233836ab&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-233836ab"]])

export default __exports__